import type { Rateable, SliceState } from 'interfaces';
import type { ServerMerchandiseInventoryItem } from '../../hooks/InventoryHooks/useMerchandiseInventory';

import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';

const initialState: MerchandiseSliceState = {
  loading: 'idle',
  merchandises: {},
};

const merchandisesSlice = createSlice({
  name: 'merchandises',
  initialState,
  reducers: {
    setMerchandiseInventoryLoading(state, { payload }: PayloadAction<MerchandiseSliceState['loading']>) {
      state.loading = payload;
    },
    addMerchandise(
      state,
      {
        payload,
      }: PayloadAction<
        Pick<ServerMerchandiseInventoryItem, 'TemplateCode' | 'TemplateName' | 'TemplateImage' | 'MeasureName'>
      >,
    ) {
      const { TemplateCode: merchandiseId, TemplateName: name, TemplateImage: image, MeasureName: unitText } = payload;
      const merchandise: Merchandise = {
        id: merchandiseId,
        imageUrl: image,
        name,
        rating: 0,
        ratingCount: 0,
        unitText,
      };
      state.merchandises[merchandiseId] = merchandise;
    },
  },
});

const { actions, reducer } = merchandisesSlice;

export const { addMerchandise } = actions;

export default reducer;
export interface Merchandise extends Rateable {
  id: string;
  name: string;
  imageUrl: string;
  unitText: string;
}

type MerchandiseSliceState = SliceState<'merchandises', Merchandise>;
